// PostOperativeCare.js
import React from 'react';
import ServiceHero from '../components/ServiceHero';
import PostOpHealingSection from '../components/PostOpHealingSection';
import ProudlyCaringSeniorsSection from '../components/ProudlyCaringSeniorsSection';
import RecoverSafelySection from '../components/RecoverSafelySection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const PostOperativeCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: '/services' },
    { label: 'Post-Operative Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <ServiceHero
        breadcrumbs={breadcrumbs}
        title="Safe and Supportive Post-Operative Care at Home"
        description="Our caregivers ensure a smooth recovery after surgery—offering gentle support, medication reminders, and daily assistance in the comfort of home."
      />
      <PostOpHealingSection />
      <ProudlyCaringSeniorsSection />
      <RecoverSafelySection />
      <ThreeStepsSection />
      <AllServicesShowcase />
    </div>
  );
};

export default PostOperativeCare;
